<template>
  <div class="image-album">
    <edit-file class="short align-top" uploadFront="true" folder="audiobooks" :name="`file_${index}`" v-if="isLoaded" title="Аудиофайл"/>
    <edit-input title="Название аудиофайла" :name="`name_${this.index}`"/>
    <div class="buttons">
      <button @click="swap('Up')" v-if="index > 0">Вверх</button>
      <button @click="swap('Down')" v-if="index+1 !== audio_files.length">Вниз</button>
      <button @click="deleteItem" v-if="!(audio_files.length === 1 && index === 0)">Удалить</button>
    </div>
  </div>
</template>

<script>
  import EditInput from '@/components/edit-form/new-items/Input'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')
  export default {
    name: "AudioEdit",
    props: ['file', 'name', 'index'],
    data() {
      return {
        deleteIndex: 0
      }
    },
    computed: {
      ...mapState([
        'isLoaded',
        'errors',
        'item',
        'audio_files'
      ])
    },
    methods: {
      ...mapMutations([
        'setErrors',
        'setItemField',
        'deleteItemField',
        'setFileExtension',
        'setAudioFiles'
      ]),
      deleteItem() {
        let object = [];
        for (let i = 0; i < this.audio_files.length; i++) {
          object.push({file: this.item[`file_${i}`], name: this.item[`name_${i}`]})
        }
        this.setAudioFiles([]);
        object.splice(this.index, 1);
        window.requestAnimationFrame(() => {
          this.setAudioFiles(object);
        })
        this.deleteItemField(`file_${this.index}`);
        this.deleteItemField(`name_${this.index}`);
      },
      swap(direction) {
        let object = JSON.parse(JSON.stringify(this.audio_files));
        for (let i = 0; i < object.length; i++) {
          object[i] = {
            file: this.item[`file_${i}`],
            name: this.item[`name_${i}`]
          }
        }
        this.setAudioFiles([]);
        if (direction === 'Up') {
          [object[this.index - 1], object[this.index]] = [object[this.index], object[this.index - 1]];
        } else {
          [object[this.index], object[this.index + 1]] = [object[this.index + 1], object[this.index]];
        }
        window.requestAnimationFrame(() => {
          this.setAudioFiles(object);
        })


      },
    },
    created() {
      this.deleteIndex = this.index;
      this.setItemField({fieldName: `file_${this.index}`, value: this.file});
      this.setItemField({fieldName: `name_${this.index}`, value: this.name});
      let errors = JSON.parse(JSON.stringify(this.errors));
      errors[`file_${this.index}`] = {message: 'Допустимые расширения: mp3, wma, acc', hasError: false};
      errors[`name_${this.index}`] = {message: 'Введите название аудиозаписи', hasError: false};
      this.setErrors(errors);
      this.setFileExtension({name: `file_${this.index}`, value: ['mp3', 'wma', 'acc']})
    },
    components: {
      EditInput,
      EditFile
    }
  }
</script>

<style lang="scss" scoped>
  .buttons {
    display: flex;
    justify-content: flex-end;
    button {
      color: #fff;
      background: #089cd3;
      border-radius: 20px;
      border: 1px solid #089cd3;
      padding: 3px;
      width: 85px;
      margin-right: 5px;
      font-size: 15px;
      transition: .3s;
      &:hover {
        background-color: transparent;
        color: #089cd3;
        cursor: pointer;
        transition: .3s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/Audio.vue